<template>
  <article v-if="content" class="flex items-center gap-300">
    <NuxtImg
      v-if="content.logo"
      :alt="content.logo.title"
      class="logo"
      :height="content.logo.height"
      :src="content.logo.url"
      :width="content.logo.width"
    />

    <span>
      <span class="headline-h5-headline">
        {{ content.headline }}
      </span>

      <p class="mt-100 caption-regular text-secondary-secondary">
        {{ content.caption }}
      </p>
    </span>
  </article>
</template>

<script lang="ts" setup>
const { data: footer } = useContent().getFooter()

const content = computed(() => {
  if (!footer.value?.items?.[0]?.registeredCourier) return null
  const { caption, headline, logo } = footer.value.items[0].registeredCourier

  // TODO Remove fallbacks when contentful schema finally gets it’s shit together
  return {
    caption: caption ?? '',
    headline: headline ?? '',
    logo: logo
      ? {
          height: logo.height ?? 0,
          title: logo.title ?? '',
          url: logo.url ?? '',
          width: logo.width ?? 0,
        }
      : null,
  }
})
</script>

<style lang="scss" scoped>
.logo {
  width: 6.25rem;
}
</style>
